/* Copyright (c) Trimble Inc. All rights reserved. */

import React from 'react';
import { Button, ErrorBoundary, Modal, Typography } from '@tcp-base/design-system';
import { SessionExpiryDialogViewerProps } from './SessionExpiryDialog.model';

const SessionExpiryDialogViewer: React.FC<SessionExpiryDialogViewerProps> = ({
  modalRef,
  countdown,
  onStaySignedIn,
  onLogout,
}) => {
  return (
    <ErrorBoundary onError={onLogout}>
      <Modal
        ref={modalRef}
        modalId='session-expiry-dialog'
        showClose={false}
        backdrop='static'
        fullscreen={undefined}
        position='center'
      >
        <span slot='header'>Session expiring soon</span>

        <div slot='content' style={{ marginBottom: '16px' }}>
          <Typography size='md'>
            Your session will end in <strong>{countdown}</strong> second{countdown !== 1 ? 's' : ''}{' '}
            due to inactivity. Extend your session to keep your current progress and continue
            working.
          </Typography>
        </div>

        <div slot='footer' style={{ display: 'flex', gap: '16px', flexDirection: 'row-reverse' }}>
          <Button color='primary' variant='filled' size='md' onClick={onStaySignedIn} autoFocus>
            Stay signed in
          </Button>
          <Button color='tertiary' variant='filled' size='md' onClick={onLogout}>
            Sign out
          </Button>
        </div>
      </Modal>
    </ErrorBoundary>
  );
};

export default SessionExpiryDialogViewer;
